import React from 'react'
import styled, { css } from 'styled-components'
import { Paper } from '@material-ui/core'
import {
  RED,
  BLACK_RGB,
  PURPLE,
  PRIMARY_TEXT,
  WHITE,
  TERTIARY_TEXT,
  PURPLE_HOVER,
} from 'constants/colors'

type FlexProps = React.HTMLProps<HTMLDivElement> & {
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
  align?: 'stretch' | 'center' | 'flex-start' | 'flex-end'
  direction?: 'row' | 'column' | 'initial'
  justify?:
    | 'left'
    | 'center'
    | 'right'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  ${props => props.wrap && { flexWrap: props.wrap }}
  ${props => props.align && { alignItems: props.align }}
  ${props => props.direction && { flexDirection: props.direction }}
  ${props => props.justify && { justifyContent: props.justify }}
`

export const truncateStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const InvalidEmptyValue = styled.div`
  color: ${RED};
`

export const FormBasic = styled.form`
  padding: 15px 20px;
  border-radius: 4px;
  background-color: ${WHITE};
  box-shadow: 0 1px 3px 0 rgba(${BLACK_RGB}, 0.2),
    0 1px 1px 0 rgba(${BLACK_RGB}, 0.14),
    0 2px 1px -1px rgba(${BLACK_RGB}, 0.12);
`

export const RedAsterisk = styled.span`
  color: ${RED};
  line-height: 14px;
  font-weight: 500;
`

export const DatePickerPaper = styled(Paper)`
  .MuiPickersBasePicker-container {
    color: ${PRIMARY_TEXT};
  }

  .MuiPickersToolbar-toolbar {
    background-color: ${PURPLE};
  }

  .MuiPickersYear-root {
    &.MuiPickersYear-yearDisabled {
      color: ${TERTIARY_TEXT};
    }

    &.MuiPickersYear-yearSelected {
      color: ${PURPLE};
    }

    &:focus {
      color: ${PURPLE};
    }

    &:hover {
      background-color: ${PURPLE_HOVER};
    }
  }

  .MuiPickersCalendarHeader-dayLabel {
    color: ${TERTIARY_TEXT};
  }

  .MuiPickersCalendarHeader-iconButton {
    color: ${PRIMARY_TEXT};

    &:hover {
      background-color: ${PURPLE_HOVER};
      color: ${PURPLE};
    }
  }

  .MuiPickersDay-day {
    color: ${PRIMARY_TEXT};

    &.MuiPickersDay-dayDisabled {
      color: ${TERTIARY_TEXT};
    }

    &.MuiPickersDay-daySelected {
      background-color: ${PURPLE};
      color: ${WHITE};
    }

    &.MuiPickersDay-current:not(.MuiPickersDay-daySelected):after {
      background: ${PURPLE};
      content: '';
      position: absolute;
      bottom: 4px;
      left: 50%;
      -webkit-transform: translate(-50%, 0);
      transform: translate(-50%, 0);
      width: 18px;
      height: 2px;
      border-radius: 2px;
    }

    &:not(.MuiPickersDay-daySelected):hover {
      border: 1px solid ${PURPLE};
      background-color: transparent;
    }
  }
`

export const TimePickerPaper = styled(Paper)`
  .MuiPickersTimePickerToolbar-toolbarAmpmLeftPadding {
    padding-left: 25px;
  }

  .MuiPickersBasePicker-container,
  .MuiPickersClockNumber-clockNumber {
    color: ${PRIMARY_TEXT};
  }

  .MuiPickersToolbar-toolbar {
    background-color: ${PURPLE};
  }

  .MuiPickersClock-pin,
  .MuiPickersClockPointer-pointer,
  .MuiPickersClockPointer-thumb,
  .MuiPickersClockPointer-noPoint {
    background-color: ${PURPLE};
  }

  .MuiPickersClockPointer-thumb {
    border-color: ${PURPLE};
  }

  .MuiPickersClock-clock {
    color: ${TERTIARY_TEXT};
  }

  .MuiPickersClockNumber-clockNumberSelected {
    color: ${WHITE};
  }
`
